'use client'

import { useSearch } from 'storefront-modules/search/hooks'
import { useGoogleAnalytics } from 'storefront-modules/third-party'
import { useAppConfigContext } from '#/src/appConfig'

export const useCustomSearch = () => {
  const appConfig = useAppConfigContext()
  const GA = useGoogleAnalytics()

  const onSubmit = (value: string) => {
    GA.search(value)
  }

  return useSearch({
    config: {
      paths: {
        searchApi: '/api/search',
        searchPage: '/search'
      },
      onSubmit
    },
    searchQueryMinLength: appConfig.searchQueryMinLength
  })
}
